import groupBy from 'lodash.groupby';

// https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
export const FULL_LANGUAGE_LOCAL_NAME = {
  'aa': 'Afar',
  'ab': 'Аҧсуа',
  'af': 'Afrikaans',
  'ak': 'Akana',
  'als': 'Alemannisch',
  'am': 'አማርኛ',
  'an': 'Aragonés',
  'ang': 'Englisc',
  'ar': 'العربية',
  'arc': 'ܣܘܪܬ',
  'arz': 'مصرى',
  'as': 'অসমীয়া',
  'ast': 'Asturianu',
  'av': 'Авар',
  'awa': 'Awadhi',
  'ay': 'Aymar',
  'az': 'Azərbaycanca / آذربايجان',
  'ba': 'Башҡорт',
  'bar': 'Boarisch',
  'bcl': 'Bikol Central',
  'be': 'Беларуская',
  'bg': 'Български',
  'bh': 'भोजपुरी',
  'bi': 'Bislama',
  'bm': 'Bamanankan',
  'bn': 'বাংলা',
  'bo': 'བོད་ཡིག / Bod skad',
  'bpy': 'ইমার ঠার/বিষ্ণুপ্রিয়া মণিপুরী',
  'br': 'Brezhoneg',
  'brx': 'बड़',
  'bs': 'Bosanski',
  'bug': 'ᨅᨔ ᨕᨘᨁᨗ / Basa Ugi',
  'bxr': 'Буряад хэлэн',
  'ca': 'Català',
  'cdo': 'Mìng-dĕ̤ng-ngṳ̄ / 閩東語',
  'ce': 'Нохчийн',
  'ceb': 'Sinugboanong Binisaya',
  'ch': 'Chamoru',
  'cho': 'Choctaw',
  'chr': 'ᏣᎳᎩ',
  'chy': 'Tsetsêhestâhese',
  'ckb': 'کوردی',
  'co': 'Corsu',
  'cr': 'Nehiyaw',
  'crn': 'crnogorski',
  'cs': 'Česky',
  'csb': 'Kaszëbsczi',
  'cu': 'словѣньскъ / slověnĭskŭ',
  'cv': 'Чăваш',
  'cy': 'Cymraeg',
  'da': 'Dansk',
  'de': 'Deutsch',
  'diq': 'Zazaki',
  'dsb': 'Dolnoserbski',
  'dv': 'ދިވެހިބަސް',
  'dz': 'རྫོང་ཁ',
  'ee': 'Ɛʋɛ',
  'el': 'Ελληνικά',
  'en': 'English',
  'eo': 'Esperanto',
  'es': 'Español',
  'et': 'Eesti',
  'eu': 'Euskara',
  'ext': 'Estremeñu',
  'fa': 'فارسی',
  'ff': 'Fulfulde',
  'fi': 'Suomi',
  'fiu-vro': 'Võro',
  'fj': 'Na Vosa Vakaviti',
  'fo': 'Føroyskt',
  'fr': 'Français',
  'frp': 'Arpitan / francoprovençal',
  'fur': 'Furlan',
  'fy': 'Frysk',
  'ga': 'Gaeilge',
  'gan': '贛語',
  'gbm': 'गढ़वळी',
  'gd': 'Gàidhlig',
  'gil': 'Taetae ni kiribati',
  'gl': 'Galego',
  'gn': "Avañe'ẽ",
  'got': 'gutisk',
  'gu': 'ગુજરાતી',
  'gv': 'Gaelg',
  'ha': 'هَوُسَ',
  'hak': '客家語/Hak-kâ-ngî',
  'haw': 'Hawai`i',
  'he': 'עברית',
  'hi': 'हिन्दी',
  'ho': 'Hiri Motu',
  'hr': 'Hrvatski',
  'ht': 'Krèyol ayisyen',
  'hu': 'Magyar',
  'hy': 'Հայերեն',
  'hz': 'Otsiherero',
  'ia': 'Interlingua',
  'id': 'Bahasa Indonesia',
  'ie': 'Interlingue',
  'ig': 'Igbo',
  'ii': 'ꆇꉙ / 四川彝语',
  'ik': 'Iñupiak',
  'ilo': 'Ilokano',
  'inh': 'ГӀалгӀай',
  'io': 'Ido',
  'is': 'Íslenska',
  'it': 'Italiano',
  'iu': 'ᐃᓄᒃᑎᑐᑦ',
  'ja': '日本語',
  'jbo': 'Lojban',
  'jv': 'Basa Jawa',
  'ka': 'ქართული',
  'kg': 'KiKongo',
  'ki': 'Gĩkũyũ',
  'kj': 'Kuanyama',
  'kk': 'Қазақша',
  'kl': 'Kalaallisut',
  'km': 'ភាសាខ្មែរ',
  'kn': 'ಕನ್ನಡ',
  'khw': 'کھوار',
  'ko': '한국어',
  'kr': 'Kanuri',
  'ks': 'कॉशुर / کٲشُر',
  'ksh': 'Ripoarisch',
  'ku': 'Kurdî',
  'kv': 'Коми',
  'kw': 'Kernewek',
  'ky': 'Kırgızca / Кыргызча',
  'la': 'Latina',
  'lad': 'Dzhudezmo / Djudeo-Espanyol',
  'lan': 'Leb Lango / Luo',
  'lb': 'Lëtzebuergesch',
  'lg': 'Luganda',
  'li': 'Limburgs',
  'lij': 'Líguru',
  'lmo': 'Lumbaart',
  'ln': 'Lingála',
  'lo': 'ລາວ / Pha xa lao',
  'lzz': 'Lazuri / ლაზური',
  'lt': 'Lietuvių',
  'lv': 'Latviešu',
  'mg': 'Malagasy',
  'man': '官話/官话',
  'mh': 'Kajin Majel / Ebon',
  'mi': 'Māori',
  'min': 'Minangkabau',
  'mk': 'Македонски',
  'ml': 'മലയാളം',
  'mn': 'Монгол',
  'mo': 'Moldovenească',
  'mr': 'मराठी',
  'mrh': 'Mara',
  'ms': 'Bahasa Melayu',
  'mt': 'bil-Malti',
  'mus': 'Mvskoke',
  'mwl': 'Mirandés',
  'my': 'Myanmasa',
  'na': 'Dorerin Naoero',
  'nah': 'Nahuatl',
  'nap': 'Nnapulitano',
  'nd': 'Sindebele',
  'nds': 'Plattdüütsch',
  'nds-nl': 'Nedersaksisch',
  'ne': 'नेपाली',
  'new': 'नेपालभाषा / Newah Bhaye',
  'ng': 'Oshiwambo',
  'nl': 'Nederlands',
  'nn': 'Norsk (nynorsk)',
  'no': 'Norsk (bokmål / riksmål)',
  'nr': 'isiNdebele',
  'nso': 'Sesotho sa Leboa / Sepedi',
  'nrm': 'Nouormand / Normaund',
  'nv': 'Diné bizaad',
  'ny': 'Chi-Chewa',
  'oc': 'Occitan',
  'oj': 'ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin',
  'om': 'Oromoo',
  'or': 'ଓଡ଼ିଆ',
  'os': 'Иронау',
  'pa': 'ਪੰਜਾਬੀ / پنجابی',
  'pag': 'Pangasinan',
  'pam': 'Kapampangan',
  'pap': 'Papiamentu',
  'pdc': 'Deitsch',
  'pi': 'Pāli / पाऴि',
  'pih': 'Norfuk',
  'pl': 'Polski',
  'pms': 'Piemontèis',
  'ps': 'پښتو',
  'pt': 'Português',
  'qu': 'Runa Simi',
  'rm': 'Rumantsch',
  'rmy': 'Romani / रोमानी',
  'rn': 'Kirundi',
  'ro': 'Română',
  'roa-rup': 'Armâneashti',
  'ru': 'Русский',
  'rw': 'Kinyarwandi',
  'sa': 'संस्कृतम्',
  'sc': 'Sardu',
  'scn': 'Sicilianu',
  'sco': 'Scots',
  'se': 'Davvisámegiella',
  'sg': 'Sängö',
  'sh': 'Srpskohrvatski / Српскохрватски',
  'si': 'සිංහල',
  'simple': 'Simple English',
  'sk': 'Slovenčina',
  'sl': 'Slovenščina',
  'sm': 'Gagana Samoa',
  'sn': 'chiShona',
  'so': 'Soomaaliga',
  'sq': 'Shqip',
  'sr': 'Српски',
  'ss': 'SiSwati',
  'st': 'Sesotho',
  'su': 'Basa Sunda',
  'sv': 'Svenska',
  'sw': 'Kiswahili',
  'ta': 'தமிழ்',
  'te': 'తెలుగు',
  'tet': 'Tetun',
  'tg': 'Тоҷикӣ',
  'th': 'ไทย / Phasa Thai',
  'ti': 'ትግርኛ',
  'tk': 'Туркмен / تركمن',
  'tl': 'Tagalog / ᜆᜄᜎᜓᜄ᜔',
  'tlh': 'tlhIngan-Hol',
  'tn': 'Setswana',
  'to': 'Lea Faka-Tonga',
  'tpi': 'Tok Pisin',
  'tr': 'Türkçe',
  'ts': 'Xitsonga',
  'tt': 'Tatarça',
  'tum': 'chiTumbuka',
  'tw': 'Twi',
  'ty': 'Reo Mā`ohi',
  'udm': 'Удмурт кыл',
  'ug': 'Uyƣurqə / ئۇيغۇرچە',
  'uk': 'Українська',
  'ur': 'اردو',
  'uz': 'Ўзбек',
  'uz_AF': 'اوزبیکی',
  've': 'Tshivenḓa',
  'vi': 'Tiếng Việt',
  'vec': 'Vèneto',
  'vls': 'West-Vlaoms',
  'vo': 'Volapük',
  'wa': 'Walon',
  'war': 'Winaray / Binisaya Lineyte-Samarnon',
  'wo': 'Wollof',
  'xal': 'Хальмг',
  'xh': 'isiXhosa',
  'xmf': 'მარგალური',
  'yi': 'ייִדיש',
  'yo': 'Yorùbá',
  'za': 'Cuengh / Tôô / 壮语',
  'zg': 'ⵜⴰⵎⴰⵣⵉⵖⵜ',
  'zh': '中文',
  'zu': 'isiZulu',
  'nb': 'Norsk (bokmål)',
};

export const AVAILABLE_LOCALE_FILES = [
  'ar_ae', 'ar_bh', 'ar_eg', 'ar_jo', 'ar_kw', 'ar_ma',
  'ar_om', 'ar_qa', 'ar_sa', 'be_by', 'bg_bg', 'bs_ba',
  'cs_cz', 'da_dk', 'de_at', 'de_ch', 'de_de', 'de_lu',
  'ee_ee', 'el_gr', 'en_am', 'en_au', 'en_az', 'en_ca',
  'en_cn', 'en_gb', 'en_ge', 'en_id', 'en_in', 'en_kg',
  'en_kr', 'en_kz', 'en_lb', 'en_lv', 'en_me', 'en_my',
  'en_nz', 'en_ph', 'en_sg', 'en_th', 'en_tw', 'en_us',
  'en_uz', 'en_vn', 'en_xk', 'es_ar', 'es_co', 'es_es',
  'es_mx', 'fi_fi', 'fr_be', 'fr_ca', 'fr_ch', 'fr_fr',
  'fr_lu', 'ga_ie', 'he_il', 'hr_hr', 'hu_hu', 'it_ch',
  'it_it', 'lt_lt', 'mk_mk', 'nb_no', 'nl_be', 'nl_nl',
  'pl_pl', 'pt_br', 'pt_pt', 'ro_ro', 'ru_ru', 'se_se',
  'sl_si', 'sq_al', 'sr_rs', 'sv_sk', 'tr_tr', 'uk_ua'
] as const;

export const AVAILABLE_LOCALES_POP_UP = [
  'ar-AE', 'ar-BH', 'ar-EG', 'ar-JO', 'ar-KW', 'ar-MA',
  'ar-OM', 'ar-QA', 'ar-SA', 'be-BY', 'bg-BG', 'bs-BA',
  'cs-CZ', 'da-DK', 'de-AT', 'de-CH', 'de-DE', 'de-LU',
  'ee-EE', 'el-GR', 'en-AM', 'en-AU', 'en-AZ', 'en-CA',
  'en-CN', 'en-GB', 'en-GE', 'en-ID', 'en-IN', 'en-KG',
  'en-KR', 'en-KZ', 'en-LB', 'en-LV', 'en-ME', 'en-MY',
  'en-NZ', 'en-PH', 'en-SG', 'en-TH', 'en-TW', 'en-US',
  'en-UZ', 'en-VN', 'en-XK', 'es-AR', 'es-CO', 'es-ES',
  'es-MX', 'fi-FI', 'fr-BE', 'fr-CA', 'fr-CH', 'fr-FR',
  'fr-LU', 'ga-IE', 'he-IL', 'hr-HR', 'hu-HU', 'it-CH',
  'it-IT', 'lt-LT', 'mk-MK', 'nb-NO', 'nl-BE', 'nl-NL',
  'pl-PL', 'pt-BR', 'pt-PT', 'ro-RO', 'ru-RU', 'se-SE',
  'sl-SI', 'sq-AL', 'sr-RS', 'sv-SK', 'tr-TR', 'uk-UA'
] as const;

export const LOCALE_RTL = ['ar', 'he'] as const

export const GET_AVAILABLE_LOCALES_DETAILS = () => {
  return AVAILABLE_LOCALES_POP_UP.map(item => {
    const lang = item.split('-')[0];
    const country = item.split('-')[1];
    if (!country) return null;
    return {
      locale: item,
      langName: FULL_LANGUAGE_LOCAL_NAME[lang] ?? '',
      country,
      langOnly: lang,
    };
  }).filter(Boolean);
};

export const GROUP_AVAILABLE_LOCALE_BY_COUNTRY = () => {
  return groupBy(GET_AVAILABLE_LOCALES_DETAILS(), 'country');
};
